import type { QueryObject } from 'ufo'
import type { ModuleOptions } from '../../types/module'
import type { ExtendedFetchOptions, ExtendedFetchUrl } from './fetch'
import { defu } from 'defu'
import { useRuntimeConfig } from 'nuxt/app'
import { joinURL, withQuery } from 'ufo'
import { CONFIG_KEY } from '../config'
import { useBackendFetch } from './backend'

export function useDashboardFetch<DataT>(
  url: ExtendedFetchUrl,
  options?: ExtendedFetchOptions<DataT>,
) {
  return useBackendFetch<DataT>(url, defu(options, {
    baseURL: (useRuntimeConfig().public[CONFIG_KEY] as ModuleOptions).dashboard.apiUrl,
  }))
}

interface UseDashboardAppUrlOptions {
  path?: string
  query?: QueryObject
}

export function useDashboardAppUrl() {
  return function (options?: UseDashboardAppUrlOptions) {
    return withQuery(
      joinURL((useRuntimeConfig().public[CONFIG_KEY] as ModuleOptions).dashboard.appUrl, options?.path),
      options?.query,
    )
  }
}
